module.exports = __webpack_public_path__ + "media/icons/up-arrow-992ac525.png";